<template>
  <div class="promotion-dialog" v-if="isShowPromotion">
    <div class="dialog-content" style="max-width: 1000px; width: 95vw; margin-top: 40px;">
      <div class="dialog-close" style="position: absolute; right: 10px; top: -36px;">
        <span @click="skip24Hours">Skip in 24hours</span>
        <span @click="closePromotion">Close <i class="el-icon-circle-close"></i></span>
      </div>
      <div class="dialog-inner">
        <img src="/assets/images/promotions/promotion-start-mar-15-2024.jpg" alt="Promotion">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShowPromotion: false
    }
  },
  created () {
    const routeName = 'OrganizationFullChart'
    localStorage.removeItem('RRG_PROMOTION_SKIP_FEB_29')
    const skipTime = localStorage.getItem('RRG_PROMOTION_SKIP_MAR_15')
    const timeValid = skipTime && skipTime > new Date().getTime()
    if (timeValid || this.$route.name === routeName) {
      this.isShowPromotion = false
    } else {
      this.isShowPromotion = true
    }
  },
  methods: {
    closePromotion () {
      this.isShowPromotion = false
    },
    skip24Hours () {
      const currentTime = new Date().getTime() + 86400000
      localStorage.setItem('RRG_PROMOTION_SKIP_MAR_15', currentTime)
      this.closePromotion()
    }
  }
}
</script>
